(function ($) {

    $(function () {

        var productGalleryWrapper = $('.shop-product-section .product-wrapper');

        if (productGalleryWrapper.length < 1) {
            return;
        }

        productGalleryWrapper.find('.product-wrapper__left .images .bt-product-image').magnificPopup({
            'type': 'image',
            gallery: {
                enabled: true,
            }
        });

    });

})(jQuery);